import React from "react";
import Modal from "../TicketComponents/Modal";

export default function FileInputModal ({imageInput}) {

    return (
        <Modal
            isOpen={false}
            onClose={() => {}}
            title="Upload Image"
        >
            <div>
                <label for="myfile">Select a file:</label>
                <input type="file" className="myfile" name="myfile" />
            </div>

            <div>   
                <label for="filecaption">Caption:</label>
                <textarea  rows="5" cols="30" className="filecaption" name="filecaption" />
            </div>
        </Modal>
    );
}